/* eslint-disable */
import axios from '../../../../core/services/axios';

/** With initiative_id & organization_id */
export const getChatMessages = (id, params) =>
  axios.get(`/api/recruits/${id}/get-sms-messages`, { params });

export const postSendMessage = (id, message, initiative_id, organization_id) =>
  axios.post(`/api/recruits/${id}/send-sms-message`, { message, initiative_id, organization_id });
